"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
function NewsGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[400px] bg-muted/50 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 text-secondary">
        <p>Unable to load resources at this time.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-center py-12 text-secondary">
        <p>No recent articles available.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} data-index={i} className="group block h-full focus:outline-none focus-visible:ring-2 focus-visible:ring-primary">
          <Card className="h-full overflow-hidden border-none shadow-md hover:shadow-lg transition-all duration-300 bg-card">
            <div className="relative aspect-[4/3] overflow-hidden bg-muted rounded-t-[6px]">
              <img src={post.featuredImage || `/img/roofing_resource_${i % 3 + 1}.png`} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              {}
              {post.categories && post.categories.length > 0 && <div className="absolute top-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <Badge variant="secondary" className="bg-primary text-primary-foreground">
                    {post.categories[0].name}
                  </Badge>
                </div>}
            </div>
            <CardContent className="p-6 flex flex-col gap-3">
              <div className="text-xs text-secondary font-medium uppercase tracking-wider">
                {post.date ? new Date(post.date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            }) : 'Expert Advice'}
              </div>
              <h3 className="font-default font-bold text-xl leading-tight text-foreground line-clamp-2 group-hover:text-primary transition-colors">
                {post.title}
              </h3>
              {post.excerpt && <p className="text-secondary text-sm line-clamp-3 mt-auto">
                  {post.excerpt.replace(/<[^>]*>?/gm, '')}
                </p>}
              <div className="flex items-center text-foreground font-bold text-sm mt-2 group/link">
                Read More
                <ArrowRight className="ml-2 size-4 text-primary transition-transform duration-300 group-hover/link:translate-x-1" />
              </div>
            </CardContent>
          </Card>
        </Link>)}
    </div>;
}
export default function VidaEnComunidad() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="234047" id="homeowner-resources" className="bg-background text-foreground py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <h2 className="font-default font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-4 tracking-tighter">
            Expert Advice & Resources
          </h2>
          <p className="text-secondary text-lg font-default">
            Learn How to Protect Your Investment
          </p>
        </div>

        <p className="text-center text-foreground mb-8 max-w-2xl mx-auto">
          Stay ahead of exterior problems. Download free maintenance guides.
        </p>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <NewsGridConsumer />
        </PostsProvider>

        <div className="mt-12 md:mt-16 flex justify-center">
          <Link className="rounded-lg px-10 font-bold bg-primary text-primary-foreground hover:scale-105 transition-transform uppercase tracking-widest underline cursor-pointer" to="/BlogPage">
            <Button variant="default" size="lg">
              Read Expert Guides + Free Checklists
              <ArrowRight className="ml-2 size-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}